import { useQuery } from '@tanstack/react-query';

import { GET_TEAM_MEMBERS_WITH_RELATIONSHIP } from '../../contracts/keys';
import { getTeamMembersWithRelationship } from '../api/teams';
import { useQueryUser } from './useQueryUser';

export function useQueryTeamMembersWithRelationshipCore(
  teamId: string | undefined,
  enabled: boolean
) {
  const { data: userData } = useQueryUser();

  return useQuery({
    queryKey: [GET_TEAM_MEMBERS_WITH_RELATIONSHIP, { teamId }],
    enabled: !!userData && !!teamId && enabled,
    // Member list must update on focus. Only mounted while viewing a team.
    staleTime: 60_000,
    queryFn: async () => {
      const { data } = await getTeamMembersWithRelationship(teamId!);
      return data;
    },
  });
}
